import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { RoutingService } from '../../service/routing.service';
import { ConfigService } from '../../service/config.service';
import { resolveLogo } from '../../shared/utils/branding.utils';

/**
 * This dialog display different error message.
 */

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['../login/login.component.scss', './message.component.scss'],
})
export class MessageComponent {
  /**
   * message id
   */
  message: string;

  /**
   * message to show on error
   */
  errorMessage: string;

  /**
   * project of the enviroment
   */
  project: string;

  /**
   * logo of the project
   */
  logo: string;

  /**
   * Static status/error messages keyed by the `:id` route param. Special-cased
   * ids (error404, nosubscription, errorMessage, autherror) keep dedicated
   * markup in the template.
   */
  messages: Record<string, string> = {
    welcome: 'Welcome to Yukka',
    expired: 'Your session has expired, please login again.',
    newuser: 'You have registered a new account, it still has to be approved.',
    password: 'Please check your email inbox to reset the password.',
    notadmin: 'Only the administrator can enter in this area.',
    notreview: 'Only the admin or review can enter in this area.',
    email:
      'Your email address has to be verified. Please check your email inbox.',
    approve: 'Your account still has to be approved.',
    blocked: 'This account is currently under review.',
    logout: 'LOGOUT',
  };

  /**
   * constructor
   */
  constructor(
    /**
     * ActivatedRoute
     */
    private route: ActivatedRoute,
    /**
     * AuthService
     */
    private auth: AuthService,
    /**
     * RoutingService
     */
    public routing: RoutingService,
    /**
     * ConfigService
     */
    private config: ConfigService,
  ) {
    this.project = this.config.appConfig.routing.project;
    this.route.params.subscribe((params) => {
      if (params.id) {
        this.message = params.id;
      }
      this.logo = resolveLogo(this.project);
      if (this.message === 'logout') {
        this.auth.authLogout();
      }
    });
    this.route.queryParams.subscribe((params) => {
      if (params.error_message) {
        this.errorMessage = params.error_message;
      }
    });
  }
}
